export default __webpack_public_path__ + "static/media/logo-dark.17682477.svg";